
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RescheduleService } from '../reschedule.service';
import { ClientData } from '../client-data';
import { AppointmentDetails } from '../appointment-details';
import { FormsModule } from '@angular/forms';
import { AppointmentPickerPropertiesService } from '../../appointment-picker-properties.service';
import { AppointmentPickerComponent } from '../../appointment-picker/appointment-picker.component';
// import { ModalService } from '../../modal/modal.service';
import { MatDialog } from '@angular/material/dialog';
import { CancelAppointment } from './cancel-appointment.component';

@Component({
    selector: 'app-reschedule',
    imports: [
    FormsModule,
    AppointmentPickerComponent
],
    templateUrl: './reschedule.component.html',
    styleUrl: './reschedule.component.scss'
})
export class RescheduleComponent {
  token: string
  tokenExists: boolean | undefined
  invalidForRescheduleReason: string | undefined
  phoneNumberToCall: string | undefined
  clientData: ClientData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  }
  city: string = ''
  validForReschedule = true
  validatingClientInformation = false
  clientInformationValidated = false
  invalidClientInformation = false
  currentAppointment: AppointmentDetails | undefined
  // appointmentPickerSharedProperties = AppointmentPickerPropertiesService.getSharedProperties();
  submittingReschedule = false;
  rescheduleSuccessMessage: string | null = null;
  emailButton = {
    'disabled': false,
    'text': 'Email Me this Confirmation'
  };
  appointmentCancelled = false

  constructor(
    private reschedule: RescheduleService,
    route: ActivatedRoute, 
    private appointmentPickerProperties: AppointmentPickerPropertiesService,
    private dialog: MatDialog) {
    this.token = route.snapshot.queryParams['token']
  }

  ngOnInit() {
    this.reschedule.doesToeknExist(this.token).subscribe( response => {
      if (response.success == true) {
        this.tokenExists = response.exists
        this.validForReschedule = response.valid ?? false
        if (response.valid === false){
          this.invalidForRescheduleReason = response.reason
          this.phoneNumberToCall = response.phoneNumber
        }
      }
    })
  }

  validateClientInformation() {
    // if (this.validatingClientInformation || this.clientInformationValidated) {
    //   return
    // }

    const firstName = this.clientData.firstName
    const lastName = this.clientData.lastName
    const email = this.clientData.email
    const phone = this.clientData.phone
    this.invalidClientInformation = false

    this.reschedule.validateClientInformation(this.token, firstName, lastName, email, phone)
      .subscribe({
        next: (response) => {
          if (response == null || !response.success) {
            // const errorMessage = response ? response.error : 'There was an error on the server. Please refresh the page and try again.';
            // NotificationUtilities.giveNotice('Failure', errorMessage, false);
          } 
          else {
            this.clientInformationValidated = response.validated;
            if (response.validated) {
              this.city = response.city;
              this.currentAppointment = {
                'site': {
                  'siteId': 0,
                  'title': response.site.title,
                  'address': response.site.address
                },
                'scheduledTime': response.scheduledTime,
                'type': 'Residential',
              };
            } else {
              this.invalidClientInformation = true;
              // this.clientData = {firstName: '', lastName: '', email: '', phone: ''};
            }
          }
        },
        error: (err) => {
          console.error(err);
          this.invalidClientInformation = true;
          // this.clientData = {firstName: '', lastName: '', email: '', phone: ''};
        }
      });
  }
  emailConfirmation() {
    this.emailButton.disabled = true

    const firstName = this.clientData.firstName
    const lastName = this.clientData.lastName
    const email = this.clientData.email
    const phone = this.clientData.phone

    this.reschedule.emailConfirmation(this.token, firstName, lastName, email, phone)
    .subscribe( response => {
      if (response == null || !response.success) {
        // const errorMessage = response ? response.error : 'There was an error on the server. Please refresh the page and try again.';
        // NotificationUtilities.giveNotice('Failure', errorMessage, false);
        this.emailButton.disabled = false;
      } else {
        this.emailButton.text = 'Sent!';	
      }
    })
  }

        
  openCancelling() {
    if (this.token != undefined) { // this should be unecessary as there is no way to get unless appt isn't undefined. i don't like TS. 
      const dialogRef = this.dialog.open(CancelAppointment, {data: {token: this.token, clientData: this.clientData}});
      dialogRef.afterClosed().subscribe((result: Boolean) => {
        if (result) {
          // Appointment is canceled
          this.appointmentCancelled = true
        }
      })
    }
  }


  nullSettings(): boolean {
    return this.appointmentPickerProperties.selectedTime? true : false
  }
  rescheduleAppointment() {
    this.submittingReschedule = true
    if (this.appointmentPickerProperties.selectedTime){
      const firstName = this.clientData.firstName
      const lastName = this.clientData.lastName
      const email = this.clientData.email
      const phone = this.clientData.phone

      this.reschedule.rescheduleAppointment(this.token, firstName, lastName, email, phone, this.appointmentPickerProperties.selectedTime)
        .subscribe(response => {
          this.rescheduleSuccessMessage = response.message ?? null
        })
    }
  }
}
